import React from "react";
import "./ExtrapayDialog.css";

const ExtrapayDialogHeading = ({ icon = "pi pi-arrow-right-arrow-left", title, subtitle }) => (
  <div className="flex align-items-center gap-3 pr-4">
    <div
      className="border-circle flex align-items-center justify-content-center flex-shrink-0"
      style={{ width: "42px", height: "42px", border: "1px solid var(--theme-border, #EBEBEB)" }}
    >
      <i className={icon} style={{ color: "var(--theme-text-muted, #5C5C5C)" }} />
    </div>
    <div>
      <div className="text-lg font-semibold" style={{ color: "var(--theme-text)" }}>
        {title}
      </div>
      {subtitle && (
        <div className="text-sm font-normal mt-1" style={{ color: "var(--theme-text-muted)" }}>
          {subtitle}
        </div>
      )}
    </div>
  </div>
);

export default ExtrapayDialogHeading;
